import type { IImagePoster } from 'atoms/ImagePoster'
import type { ContentStateBadgeKind } from 'blocks/ContentStateBadge'
import type {
  BANNER_ASPECT_RATIO,
  BANNER_WIDTH,
  FIXED_INDENTS,
} from 'vars/index'

import { COLOR } from 'vars/index'

export interface ILayoutBlockPosterProps {
  width?: BANNER_WIDTH
  overlayEnabled?: boolean
  overlayHeight?: number
  overlayWidth?: number
  overlay?: PosterOverlay
  overlayHorizontal?: PosterOverlay
  overlayVertical?: PosterOverlay
  overlayDirection?: PosterOverlayDirection
  aspectRatio?: BANNER_ASPECT_RATIO
  posterUrl: string
  posterMobileUrl: string
  fallbackImageSize?: IImagePoster['fallbackImageSize']
  children?: React.ReactNode
  backgroundColor?: COLOR
  paddings?: FIXED_INDENTS[]
  loading?: boolean
  /** Renders the block as the content details `.banner base` shell. */
  detailsBanner?: boolean
  /** Circular PIN-lock or geoblock marker laid over the artwork. */
  stateBadge?: ContentStateBadgeKind
  /**
   * Blurs the artwork. PIN-locked content keeps its banner in the new concept,
   * so the poster has to stop being readable.
   */
  blurPoster?: boolean
}

export interface ILayoutBlockTrailerProps extends ILayoutBlockPosterProps {
  visible?: boolean
}

export const PosterOverlay = {
  None: COLOR.TRANSPARENT,
  BANNER_HORIZONTAL_OVERLAY: COLOR.BANNER_HORIZONTAL_OVERLAY,
  BANNER_VERTICAL_OVERLAY: COLOR.BANNER_VERTICAL_OVERLAY,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
} as const
export type PosterOverlay = (typeof PosterOverlay)[keyof typeof PosterOverlay]

export const PosterOverlayDirection = {
  OVERLAY_HORIZONTAL: 'OVERLAY_HORIZONTAL',
  OVERLAY_VERTICAL: 'OVERLAY_VERTICAL',
  OVERLAY_FULL: 'OVERLAY_FULL',
  OVERLAY_HORIZONTAL_VERTICAL: 'OVERLAY_HORIZONTAL_VERTICAL',
  OVERLAY_HORIZONTAL_FULL: 'OVERLAY_HORIZONTAL_FULL',
  OVERLAY_VERTICAL_FULL: 'OVERLAY_VERTICAL_FULL',
  OVERLAY_HORIZONTAL_VERTICAL_FULL: 'OVERLAY_HORIZONTAL_VERTICAL_FULL',
} as const
export type PosterOverlayDirection =
  (typeof PosterOverlayDirection)[keyof typeof PosterOverlayDirection]
